import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
    component('clearlineDealFields', {
        bindings: {
            formName: '@',
            formId: '@',
            newRecord: '<',
            deal: '<',
            dealSetting: '<',
            dealSettingOptions: '<',
            timezoneOptions: '<',
            canManageMultiCurrency: '<',
            currencyValues: '<',
            demandPartnerExpansionEnabled: '<',
            buyerClientUserAccount: '<',
            demandPartnerCount: '<',
            selectedDemandPartnerPermissionOptions: '<',
        },
        template: require("../templates/clearlineDealFields.html"),
        controllerAs: '$clearlineDealFieldsCtrl',
        controller: ['$scope', function ($scope) {

            this.statusOptions = componentHelper.statusOptions();
            this.dealNotFound = false;
            this.dealSynced = false;

            this.shouldShowBookedImps = () => {
                // Only show booked imps for Magnite Streaming when deal is pg.
                return this.isMagniteStreaming() ? this.dealSetting.auction_type === 'pg' : true;
            };

            this.isMagniteStreaming = () => {
                return this.dealSetting.ssp === 'magnite_streaming';
            };

            this.setAuctionType = (auctionType) => {
                if (!this.isMagniteStreaming()) {
                    this.dealSetting.auction_type = auctionType;
                }
            };

            this.setActiveValue = (value) => {
                this.deal.pending = false;
                this.deal.active = value;
            };

            this.setPendingValue = () => {
                this.deal.pending = true;
                this.deal.active = false;
            };

            this.timezoneDisplayToggle = () => {
                const timezoneDisplayElement = $("#clearline_deal_timezone_free");
                const timezonePickerElement = $("#clearline_deal_timezone_predefined_chosen");
                const timezonePickerSelectElement = $("#clearline_deal_timezone_predefined");
                if (this.isMagniteStreaming()) {
                    timezonePickerElement.addClass('hidden');
                    timezoneDisplayElement.removeClass('hidden');
                    timezonePickerSelectElement.attr("disabled", true);
                } else {
                    timezonePickerElement.removeClass('hidden');
                    timezoneDisplayElement.addClass('hidden');
                    timezonePickerSelectElement.attr("disabled", false);
                }
            };

            this.$onInit = () => {
                setTimeout(() => {
                    this.timezoneDisplayToggle();
                }, 0);
            };
        }]
    });
